import { SectionContainer } from 'components/DetailsView/Section';
import { TotemGallery } from 'components/TotemGallery';
import { WarehouseDeliveryFragmentFragment, GetDeliveryQuery, SiteSetupFragmentFragment } from 'data/__generated__';
import styled from 'styled-components';

export const PhotosSectionSection = ({
    warehouseDelivery,
}: {
    warehouseDelivery:
        | NonNullable<GetDeliveryQuery['delivery']>
        | (WarehouseDeliveryFragmentFragment & {
              photos: Array<{ __typename?: 'DeliveryPhoto'; type: string; urls: string[] }>;
              siteSetup?: SiteSetupFragmentFragment | null;
          });
}) => {
    const { controlPhotos } = warehouseDelivery;

    return (
        <SectionContainer title="Photos" isInitiallyOpen>
            <>
                <Title>Photos de livraison</Title>
                <TotemGallery images={controlPhotos} />
            </>
        </SectionContainer>
    );
};

const Title = styled.div`
    margin-top: 15px;
    font-weight: bold;
    font-size: 18px;
`;
